export const projectService = {
  getProjects: (api) => api.get('/projects'),
  getProject: (api, id) => api.get(`/projects/${id}`),
  getPositions: (api) => api.get('/positions'),
  getAreas: (api) => api.get('/lookups/areas'),
  getWorkZones: (api) => api.get('/lookups/work-zones'),
  getStatuses: (api) => api.get('/lookups/statuses'),
  getRequiredHeadcount: (api, params) => api.get('/headcount/required', { params }),
  getActualHeadcount: (api, params) => api.get('/headcount/actual', { params }),
  getManpowerRequests: (api, params) => api.get('/manpower-requests', { params }),
  createManpowerRequest: (api, data) => api.post('/manpower-requests', data),
  approveRequest: (api, id) => api.put(`/manpower-requests/${id}/approve`),
  seed: () => fetch(`${process.env.REACT_APP_BACKEND_URL}/api/seed`, { method: 'POST' }).then(r => r.json()),
};
